import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './styles.module.scss'

const Scrollbar = ({className, height, children}) => {
  return (
    <div style={{height}} className={classNames(styles.container, className)}>
      {children}
    </div>
  )
}

Scrollbar.defaultProps = {
  height: 320,
}

Scrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Scrollbar
